// Provenance: repo:tds-reconciliation-portal:frontend/src/components/Money.tsx (ADR-0005) —
// restyled on the estate tokens (ADR-0010).
import { fmtMoney } from '../format'

/** Monospace money value; optionally colorized by sign (for differences). */
export function Money({
  v,
  colorize = false,
  bold = false,
  className = '',
}: {
  v: string | number | null | undefined
  colorize?: boolean
  bold?: boolean
  className?: string
}) {
  const n = Number(v ?? 0)
  const tone = !colorize
    ? ''
    : n > 0.004
      ? 'text-red-700'
      : n < -0.004
        ? 'text-amber-700'
        : 'text-muted-foreground'
  return (
    <span
      className={`whitespace-nowrap font-mono text-sm ${bold ? 'font-bold' : ''} ${tone} ${className}`}
    >
      {fmtMoney(v)}
    </span>
  )
}
